const l = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.51 4.43a2.39 2.39 0 0 0-1-.63L12.6.1h-.1a2.11 2.11 0 0 0-1 0h-.1l-10 3.7a2.39 2.39 0 0 0-.95.63A2 2 0 0 0 0 5.72v12.55a2 2 0 0 0 1.31 1.87l10 3.74A2.07 2.07 0 0 0 12 24a2.24 2.24 0 0 0 .67-.11l10-3.75A2 2 0 0 0 24 18.25V5.72a2 2 0 0 0-.49-1.29ZM12 2l8 3-8 2.9L4 5ZM2 6.37l9 3.3v12l-9-3.4Z" fill="currentColor"></path></svg>';
export {
  l as default
};
